var _implements = require('util/interface')._implements;
var FetchStream = require('../../../events/fetch-stream');

module.exports = _implements(FetchStream, function FetchStreamImpl(emitter) {
    emitter.assign(this);
});


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/features/topics/fetch-stream.js
// module id = 1033
// module chunks = 1